import React, { useState } from 'react'

import _ from 'lodash'

import LABEL from '../../../business-const/Label/Label'

import {
    CardGridEntradaDados,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    GridContainer,
    GridItem2xs4,
    GridItem10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    ButtonVisualizarSucessaoVitalicia,
} from '../../../business-components/Button/Button'

import {
    IconButtonEditarLeft,
    IconButtonConfiguracao,
    IconButtonMaisInformacoes,
    IconButtonVerDetalhes,
} from '../../../business-components/IconButton/IconButton'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    dadosCompletosConjuge,
    tituloCliente,
    tituloConjuge,
} from '../cliente-form/ClienteService'

import {
    CustomizedDialogsPopupCotacao
} from '../estudo-form/EstudoComp'

import {
    IdadeClienteDisabled,
    IdadeDataSimulacaoCliente,
    IdadeVaiAposentarCliente,
    IdadeInicioInssCliente,
    IdadeExpectativaVidaCliente,
    AlterarIdadesAutomaticasCliente,
    IdadeConjuge,
    IdadeDataSimulacaoConjuge,
    IdadeVaiAposentarConjuge,
    IdadeExpectativaVidaConjuge,
    AlterarIdadesAutomaticasConjuge,
} from '../estudo-parametros/EstudoCompClienteConjuge'

import {
    AposentadoriaExpectativaVida,
} from '../estudo-parametros/EstudoCompIdades'

import {
    calculaTotaisPatrimonioImobilizado,
} from '../garantias-form/GarantiasServicePatrimonioImobilizado'

import {
    calculaTotaisRecursosFinanceiros,
} from '../garantias-form/GarantiasServiceRecursosFinanceiros'

import {
    existeTabelaEvolucaoValorResgate,
} from '../seguroVidaCotacao-form/SeguroVidaCotacaoServiceCotacao'

import EstudoFormSucessaoVitalicia from '../estudo-form/EstudoFormSucessaoVitalicia'

//import CarteiraInvestimentosChart from '../estudo-chart/CarteiraInvestimentosChart'

import EstudoFormResumoSeguroVidaCotacao from '../estudo-form/EstudoFormResumoSeguroVidaCotacao'

//import EstudoFormTabelaEvolucaoValorResgate from '../estudo-form/EstudoFormTabelaEvolucaoValorResgate'

//import EstudoFormTabelaEvolucaoCS from '../estudo-form/EstudoFormTabelaEvolucaoCS'

//import EstudoFormTabelaEvolucaoCancelamentoApolice from '../estudo-form/EstudoFormTabelaEvolucaoCancelamentoApolice'

import TabelaEvolucaoValorResgateChart from '../estudo-chart/TabelaEvolucaoValorResgateChart'

import AnaliseInvestimentoVersusSeguroVidaInteiraChart from '../estudo-chart/AnaliseInvestimentoVersusSeguroVidaInteiraChart'

import AnalisePrevidenciaPrivadaVersusSeguroVidaInteiraChart from '../estudo-chart/AnalisePrevidenciaPrivadaVersusSeguroVidaInteiraChart'

import FormFormPatrimonioImobilizado from '../form-form/FormFormPatrimonioImobilizado'

import FormFormRecursosFinanceiros from '../form-form/FormFormRecursosFinanceiros'

import EstudoFormConfiguracaoGestaoPatrimonial from '../estudo-parametros/EstudoFormConfiguracaoGestaoPatrimonial'

//import {
//    calculaTotaisReceitaMensal,
//} from '../garantias-form/GarantiasServiceReceitaMensal'

//import {
//    calculaTotaisDiaDia,
//} from '../despesas-form/DespesasServiceDiaDia'

import FormFormReceitaMensal from '../form-form/FormFormReceitaMensal'

//import FormFormDiaDia from '../form-form/FormFormDiaDia'
import EstudoFormRevisaoDados from '../estudo-form/EstudoFormRevisaoDados'

import ReceitaAnualChart from '../estudo-chart/ReceitaAnualChart'

import DespesaAnualChart from '../estudo-chart/DespesaAnualChart'

import BalancoReceitaXDespesaAnualChart from '../estudo-chart/BalancoReceitaXDespesaAnualChart'



export const CustomizedDialogsPopupPatrimonioImobilizado = ( { values, handleChange, setFieldValue,
    handleSubmitAutomatico, setRefresh, refresh } ) => {

    return (
        <CustomizedDialogsPopup
            maxWidth='lg'
            popupTitle={LABEL.patrimonioImobilizado}
            PopupButton={IconButtonEditarLeft}
            bgDefault={true}
            popupComponent={
                <div
                    className='ml-4 mr-4'
                >
                    <CardGridEntradaDados>
                        <CardGridDivBodyEntradaDados>
                            <GridContainer
                                className='mt-2'
                            >
                                <GridItem12>
                                    <FormFormPatrimonioImobilizado
                                        values={values}
                                        handleChange={handleChange}
                                        setFieldValue={setFieldValue}
                                        title={LABEL.patrimonioImobilizado}
                                    />
                                </GridItem12>
                            </GridContainer>
                        </CardGridDivBodyEntradaDados>
                    </CardGridEntradaDados>
                </div>
            }
            onClose={
                () => {
                    calculaTotaisPatrimonioImobilizado(values)
                    setRefresh(!refresh)
                    handleSubmitAutomatico(values)
                }
            }
        />
    )
}



export const CustomizedDialogsPopupRecursosFinanceiros = ( { values, handleChange, setFieldValue,
    handleSubmitAutomatico, linhaTipoLicenca/*, jsonConfiguracao*/, setRefresh, refresh } ) => {

    return (
        <CustomizedDialogsPopup
            maxWidth='lg'
            popupTitle={LABEL.recursosFinanceiros}
            PopupButton={IconButtonEditarLeft}
            bgDefault={true}
            popupComponent={
                <div
                    className='ml-4 mr-4'
                >
                    <CardGridEntradaDados>
                        <CardGridDivBodyEntradaDados>
                            <GridContainer
                                className='mt-2'
                            >
                                <GridItem12>
                                    <FormFormRecursosFinanceiros
                                        values={values}
                                        handleChange={handleChange}
                                        setFieldValue={setFieldValue}
                                        linhaTipoLicenca={linhaTipoLicenca}
                                        //jsonConfiguracao={jsonConfiguracao}
                                        title={LABEL.recursosFinanceiros}
                                    />
                                </GridItem12>
                            </GridContainer>
                        </CardGridDivBodyEntradaDados>
                    </CardGridEntradaDados>
                </div>
            }
            onClose={
                () => {
                    calculaTotaisRecursosFinanceiros(values)
                    setRefresh(!refresh)
                    handleSubmitAutomatico(values)
                }
            }
        />
    )
}



export const CustomizedDialogsPopupSucessaoVitalicia = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue,
    handleSubmitAutomatico, estudo, vars }) => {

    return (
        <CustomizedDialogsPopup
            maxWidth='lg'
            popupTitle={LABEL.sucessaoVitalicia}
            PopupButton={ButtonVisualizarSucessaoVitalicia}
            bgDefault={true}
            popupComponent={
                <>
                    <EstudoFormSucessaoVitalicia
                        values={values}
                        estudo={estudo}
                        //jsonConfiguracao={jsonConfiguracao}
                        simulacaoFinanceira={true}
                    />

                    {vars.linhaTipoLicenca.exibirCompleto/*exibirEstudo*/ === 'S' && (
                        <>
                            <CustomizedDialogsPopupCotacao
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                handleChange={handleChange}
                                handleSubmit={handleSubmit}
                                setFieldValue={setFieldValue}
                                vars={vars}
                                //setExpandiu={setExpandiu}
                            />

                            {existeTabelaEvolucaoValorResgate(values) && (
                                <>
                                    {/*
                                    <CarteiraInvestimentosChart
                                        values={values}
                                        estudo={estudo}
                                        report={false}
                                        popup={true}
                                        simulacaoFinanceira={true}
                                    />
                                    */}

                                    {estudo.current.estrategiasFinanceirasTabelaEvolucaoValorResgateSeguradoras
                                        .filter(item => !item.utilizarApenasComparacaoPreco)?.map( (cotacao, indCotacao) => (
                                            <div
                                                key={indCotacao}
                                            >
                                                {values.exibirResumoSeguroVidaCotacao && (
                                                    <EstudoFormResumoSeguroVidaCotacao
                                                        values={values}
                                                        estrategiasFinanceirasTabelaEvolucaoValorResgateSeguradoras={cotacao}
                                                        utilizarApenasComparacaoPreco={false}
                                                        report={false}
                                                    />
                                                )}

                                                {estudo.current.estrategiasFinanceirasTabelaEvolucaoValorResgate
                                                .filter(item => !item.utilizarApenasComparacaoPreco &&
                                                item.seguradora === cotacao.id)?.map( (item, ind) => (
                                                    <div
                                                        key={ind}
                                                    >
                                                        <TabelaEvolucaoValorResgateChart
                                                            values={values}
                                                            estudo={estudo}
                                                            estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                            report={false}
                                                            tabelaEvolucaoValorResgate={true}
                                                        />
                                                        {/*!values.exibirTabelaEvolucaoCS && !values.exibirTabelaEvolucaoCancelamentoApolice && (
                                                            <EstudoFormTabelaEvolucaoValorResgate
                                                                values={values}
                                                                estudo={estudo}
                                                                estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                report={false}
                                                            />
                                                        )*/}
                                                        {/*values.exibirTabelaEvolucaoCS && (
                                                            <EstudoFormTabelaEvolucaoCS
                                                                values={values}
                                                                estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                report={false}
                                                            />
                                                        )*/}
                                                        {/*values.exibirTabelaEvolucaoCancelamentoApolice && (
                                                            <EstudoFormTabelaEvolucaoCancelamentoApolice
                                                                values={values}
                                                                estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                report={false}
                                                            />
                                                        )*/}
                                                        {/*(values.exibirTabelaEvolucaoCS ||
                                                        values.exibirTabelaEvolucaoCancelamentoApolice) && (
                                                            <TabelaEvolucaoValorResgateChart
                                                                values={values}
                                                                estudo={estudo}
                                                                estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                report={false}
                                                                tabelaEvolucaoValorResgate={false}
                                                            />
                                                        )*/}
                                                        {values.exibirGraficoAnaliseInvestimentoVersusSeguroVidaInteira && 
                                                        !item.apenasExibirTabelaEvolucaoValorResgateSemTaxaInflacao && (
                                                            <AnaliseInvestimentoVersusSeguroVidaInteiraChart
                                                                values={values}
                                                                estudo={estudo}
                                                                estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                report={false}
                                                            />
                                                        )}
                                                        {values.exibirGraficoAnalisePrevidenciaPrivadaVersusSeguroVidaInteira && 
                                                        !item.apenasExibirTabelaEvolucaoValorResgateSemTaxaInflacao && (
                                                            <AnalisePrevidenciaPrivadaVersusSeguroVidaInteiraChart
                                                                values={values}
                                                                estudo={estudo}
                                                                estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                report={false}
                                                            />
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        ))
                                    }
                                </>
                            )}
                        </>
                    )}
                </>
            }
            onClose={
                () => {
                    handleSubmitAutomatico(values)
                }
            }
        />
    )
}



export const CustomizedDialogsPopupParametrosGestaoPatrimonial = ( { values, handleChange, handleSubmit,
    handleSubmitAutomatico } ) => {

    return (
        <CustomizedDialogsPopup
            maxWidth='lg'
            popupTitle={LABEL.parametrosGestaoPatrimonial}
            tooltipTitle={LABEL.parametrosGestaoPatrimonial}
            PopupButton={IconButtonConfiguracao}
            bgDefault={true}
            popupComponent={
                <div
                    className='ml-4 mr-4'
                >
                    <EstudoFormConfiguracaoGestaoPatrimonial
                        values={values}
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                        //popup={true}
                    />
                </div>
            }
            onClose={
                () => {
                    handleSubmitAutomatico(values)
                }
            }
        />
    )
}



export const AposentadoriaExpectativaVidaCliente = ({ values, setFieldValue }) => {

    const [valuesAux, setValuesAux] = useState(values.idadesClientes)

    const [idadesCliente, setIdadesCliente] = useState(values.idadesClientes)

    if (!_.isEqual(values.idadesCliente, idadesCliente)) {

        setValuesAux([...values.idadesCliente])

        setIdadesCliente([...values.idadesCliente])
    }

    const handleChangeAposentadoriaExpectativaVidaCliente = (idadesCliente) => {
        console.log(1)

        values.alterarIdadesAutomaticasCliente = true

        if (idadesCliente[0] >= values.idadeDataSimulacaoCliente) {

            values.idadeVaiAposentarCliente =
                idadesCliente[1] >= values.idadeDataSimulacaoCliente
                    ?
                        idadesCliente[1]
                    :
                        values.idadeDataSimulacaoCliente
        }

        idadesCliente[0] = values.idadeDataSimulacaoCliente

        //values.idadeExpectativaVidaCliente = idadesCliente[2]
        setFieldValue('idadeExpectativaVidaCliente', idadesCliente[2])

        

        //if (setReexibir) {

        //    setReexibir(reexibir++)
        //}
    }

    return (
        <AposentadoriaExpectativaVida
            values={valuesAux}
            setValues={setValuesAux}
            idades={idadesCliente}
            handleChange={handleChangeAposentadoriaExpectativaVidaCliente}
        />
    )
}

export const AposentadoriaExpectativaVidaClienteConjuge = ({ values, handleChange, setExpandiu }) => {

    const temConjuge = dadosCompletosConjuge(values)

    return (
        <CustomizedDialogsPopup
            maxWidth="md"
            popupTitle={LABEL.aposentadoriaExpectativaVida}
            tooltipTitle={LABEL.expandir}
            PopupButton={IconButtonMaisInformacoes}
            popupButtonDestaque={false}
            popupComponent={
                <GridContainer>
                    <GridItem10>
                        <GridContainer>
                            <GridItem2xs4
                                className='mt-5'
                            >
                                {tituloCliente(values)}
                            </GridItem2xs4>

                            <GridItem2xs4>
                                <IdadeClienteDisabled
                                    values={values}
                                    handleChange={handleChange}
                                />
                            </GridItem2xs4>

                            <GridItem2xs4>
                                <IdadeDataSimulacaoCliente
                                    values={values}
                                    handleChange={handleChange}
                                /> 
                            </GridItem2xs4>

                            <GridItem2xs4>
                                <IdadeVaiAposentarCliente
                                    values={values}
                                    handleChange={handleChange}
                                />
                            </GridItem2xs4>
                            
                            <GridItem2xs4>
                                <IdadeInicioInssCliente
                                    values={values}
                                    handleChange={handleChange}
                                />
                            </GridItem2xs4>
                            
                            <GridItem2xs4>
                                <IdadeExpectativaVidaCliente
                                    values={values}
                                    handleChange={handleChange}
                                />
                            </GridItem2xs4>

                            <GridItem2xs4
                                className='mt-2'
                            >
                                <AlterarIdadesAutomaticasCliente
                                    values={values}
                                    handleChange={handleChange}
                                />
                            </GridItem2xs4>
                        </GridContainer>

                        {temConjuge && (
                            <GridContainer>
                                <GridItem2xs4
                                    className='mt-5'
                                >
                                    {tituloConjuge(values)}
                                </GridItem2xs4>

                                <GridItem2xs4>
                                    <IdadeConjuge
                                        values={values}
                                        handleChange={handleChange}
                                    />
                                </GridItem2xs4>

                                <GridItem2xs4>
                                    <IdadeDataSimulacaoConjuge
                                        values={values}
                                        handleChange={handleChange}
                                    />
                                </GridItem2xs4>

                                <GridItem2xs4>
                                    <IdadeVaiAposentarConjuge
                                        values={values}
                                        handleChange={handleChange}
                                    />
                                </GridItem2xs4>

                                <GridItem2xs4>
                                    <IdadeExpectativaVidaConjuge
                                        values={values}
                                        handleChange={handleChange}
                                    />
                                </GridItem2xs4>

                                <GridItem2xs4
                                    className='mt-2'
                                >
                                    <AlterarIdadesAutomaticasConjuge
                                        values={values}
                                        handleChange={handleChange}
                                    />
                                </GridItem2xs4>
                            </GridContainer>
                        )}
                    </GridItem10>
                </GridContainer>
            }
            open={setExpandiu}
            onClose={() => {
                values.idadesCliente[1] = values.idadeVaiAposentarCliente
                values.idadesCliente[2] = values.idadeExpectativaVidaCliente
            }}
            afterClose={setExpandiu}
        />
    )
}



export const CustomizedDialogsPopupReceitaMensal = ( { values, handleChange, setFieldValue, handleSubmitAutomatico,
    setRefresh, refresh } ) => {

    return (
        <CustomizedDialogsPopup
            maxWidth='lg'
            popupTitle={LABEL.receitaMensal}
            PopupButton={IconButtonEditarLeft}
            bgDefault={true}
            popupComponent={
                <div
                    className='ml-4 mr-4'
                >
                    <CardGridEntradaDados>
                        <CardGridDivBodyEntradaDados>
                            <GridContainer
                                className='mt-2'
                            >
                                <GridItem12>
                                    <FormFormReceitaMensal
                                        values={values}
                                        handleChange={handleChange}
                                        setFieldValue={setFieldValue}
                                        title={LABEL.receitaMensal}
                                    />
                                </GridItem12>
                            </GridContainer>
                        </CardGridDivBodyEntradaDados>
                    </CardGridEntradaDados>
                </div>
            }
            onClose={
                () => {
                    //calculaTotaisReceitaMensal(values)
                    setRefresh(!refresh)
                    handleSubmitAutomatico(values)
                }
            }
        />
    )
}



export const CustomizedDialogsPopupDespesas = ( { variaveisGlobais, values, handleChange, handleSubmit, setFieldValue,
    handleSubmitAutomatico, vars, /*linhaTipoLicenca, jsonConfiguracao, jsonUsuario, jsonUsuarioAdmin,*/ setRefresh, refresh } ) => {

    return (
        <CustomizedDialogsPopup
            maxWidth='lg'
            popupTitle={LABEL.despesaMensal}
            PopupButton={IconButtonEditarLeft}
            bgDefault={true}
            popupComponent={
                <EstudoFormRevisaoDados
                    variaveisGlobais={variaveisGlobais}
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    handleSubmitAutomatico={handleSubmitAutomatico}
                    vars={vars}
                    //linhaTipoLicenca={linhaTipoLicenca}
                    //jsonConfiguracao={jsonConfiguracao}
                    //jsonUsuario={jsonUsuario}
                    //jsonUsuarioAdmin={jsonUsuarioAdmin}
                    somenteDespesas={true}
                    popup={true}
                />
                /*
                <FormFormDiaDia
                    values={values}
                    handleChange={handleChange}
                    setFieldValue={setFieldValue}
                    linhaTipoLicenca={linhaTipoLicenca}
                    jsonConfiguracao={jsonConfiguracao}
                    title={LABEL.diaDia}
                />
                */
            }
            onClose={
                () => {
                    //calculaTotaisDiaDia(values, jsonConfiguracao)
                    setRefresh(!refresh)
                    handleSubmitAutomatico(values)
                }
            }
        />
    )
}



export const CustomizedDialogsPopupCapacidadePoupanca = ( { variaveisGlobais, values, handleSubmitAutomatico,
    estudo, vars, setRefresh, refresh } ) => {

    return (
        <CustomizedDialogsPopup
            maxWidth='lg'
            popupTitle={LABEL.capacidadePoupanca}
            PopupButton={IconButtonVerDetalhes}
            bgDefault={true}
            popupComponent={
                <>
                    <ReceitaAnualChart
                        variaveisGlobais={variaveisGlobais}
                        values={values}
                        estudo={estudo}
                        vars={vars}
                        report={false}
                    />

                    <DespesaAnualChart
                        values={values}
                        estudo={estudo}
                        vars={vars}
                        report={false}
                    />

                    <BalancoReceitaXDespesaAnualChart
                        variaveisGlobais={variaveisGlobais}
                        values={values}
                        estudo={estudo}
                        vars={vars}
                        report={false}
                    />
                </>
            }
            onClose={
                () => {
                    //calculaTotaisDiaDia(values, jsonConfiguracao)
                    setRefresh(!refresh)
                    handleSubmitAutomatico(values)
                }
            }
        />
    )
}